import React from 'react'
import { FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap'

const RequiredMark = () => <span className="required-marker" aria-hidden="true"> *</span>

function AccountInfo(props) {
  const { disabled, invalidFieldIds = [], changeState, parentEmail = '' } = props
  const hasError = (id) => invalidFieldIds.includes(id)
  return (    
    <div className="white-text enrolment-participant-block enrolment-contact-section">
      <Row className="enrolment-participant-grid">
        <Col sm={12}>
          <div className="enrolment-section-header">
            <div className="enrolment-section-kicker">Account Holder</div>
          </div>
          <Row>
            <Col sm={3}>
              <FormGroup className={hasError("parent1_first_name") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>First Name<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent1_first_name" type="text" id="parent1_first_name" placeholder="" disabled={disabled} onChange={(e) => changeState('parent1_first_name', e.target.value)} />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup className={hasError("parent1_last_name") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>Last Name<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent1_last_name" type="text" id="parent1_last_name" placeholder="" disabled={disabled} onChange={(e) => changeState('parent1_last_name', e.target.value)} />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup className={hasError("parent1_email") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>E-mail<RequiredMark /></ControlLabel>
                <FormControl
                  className="opaque-grey"
                  name="parent1_email"
                  type="text"
                  id="parent1_email"
                  placeholder=""
                  disabled={true}
                  value={parentEmail}
                />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup className={hasError("parent1_phone") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>Phone<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent1_phone" type="text" id="parent1_phone" placeholder="" disabled={disabled} onChange={(e) => changeState('parent1_phone', e.target.value)} />
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col sm={12}>
          <div className="enrolment-section-header">
            <div className="enrolment-section-kicker">Secondary Contact</div>
          </div>
          <Row>
            <Col sm={3}>
              <FormGroup className={hasError("parent2_first_name") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>First Name<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent2_first_name" type="text" id="parent2_first_name" placeholder="" disabled={disabled} onChange={(e) => changeState('parent2_first_name', e.target.value)} />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup className={hasError("parent2_last_name") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>Last Name<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent2_last_name" type="text" id="parent2_last_name" placeholder="" disabled={disabled} onChange={(e) => changeState('parent2_last_name', e.target.value)} />
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup className={hasError("parent2_email") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>E-mail<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent2_email" type="text" id="parent2_email" placeholder="" disabled={disabled} onChange={(e) => changeState('parent2_email', e.target.value)}/>
              </FormGroup>
            </Col>
            <Col sm={3}>
              <FormGroup className={hasError("parent2_phone") ? "enrolment-invalid-field" : ""}>
                <ControlLabel>Phone<RequiredMark /></ControlLabel>
                <FormControl className="opaque-grey" name="parent2_phone" type="text" id="parent2_phone" placeholder="" disabled={disabled} onChange={(e) => changeState('parent2_phone', e.target.value)} />
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default AccountInfo
